export type Typography = typeof typography;

export const typography = {
  fonts: {
    heading: `Belfius, Helvetica, Arial, sans-serif`,
    body: `Inter, Helvetica, Arial, sans-serif`,
    ciutadella: `Ciutadella, sans-serif`,
  },

  fontSizes: {
    xxs: `0.625rem`, // 10
    xs: `0.75rem`, // 12
    sm: `0.875rem`, // 14
    md: `1rem`, // 16
    lg: `1.125rem`, // 18
    xl: `1.25rem`, // 20
    '2xl': `1.5rem`, // 24
    '3xl': `2rem`, // 32
    '4xl': `2.5rem`, // 40
    '5xl': `3rem`, // 48
    '6xl': `4rem`, // 64
  },
};
